/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import _Popconfirm from './popconfirm.mjs';
import withInstall from '../utils/withInstall.mjs';
import './style/css.mjs';
import './type.mjs';
import '../_chunks/dep-6e49aa22.mjs';
import '../_chunks/dep-6da93342.mjs';
import '../_chunks/dep-8d3c9348.mjs';
import '../_chunks/dep-d531a7f4.mjs';
import 'vue';
import 'tdesign-icons-vue-next';
import '../hooks/useConfig.mjs';
import '../config-provider/hooks/useConfig.mjs';
import 'lodash-es';
import '../config-provider/utils/context.mjs';
import '../_chunks/dep-99da72b8.mjs';
import '../_chunks/dep-b0ea6825.mjs';
import '../_chunks/dep-2705c570.mjs';
import '../_chunks/dep-bc824998.mjs';
import '../config-provider/type.mjs';
import '../hooks/useGlobalIcon.mjs';
import '../popup/index.mjs';
import '../popup/popup.mjs';
import '@popperjs/core';
import '../hooks/index.mjs';
import '../hooks/icon.mjs';
import '../hooks/slot.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-5112e56c.mjs';
import '../hooks/useCommonClassName.mjs';
import '../hooks/useDefaultValue.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../hooks/useRipple.mjs';
import '../_chunks/dep-b0b0fb5e.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../hooks/useVModel.mjs';
import '../hooks/useImagePreviewUrl.mjs';
import '../_chunks/dep-46061e10.mjs';
import '../_chunks/dep-1def7a80.mjs';
import '../utils/dom.mjs';
import '../popup/container.mjs';
import '../_chunks/dep-35b16530.mjs';
import '../popup/props.mjs';
import '../hooks/useResizeObserver.mjs';
import '../popup/type.mjs';
import './props.mjs';
import '../dialog/hooks/index.mjs';
import '../dialog/hooks/useAction.mjs';
import '../button/index.mjs';
import '../button/button.mjs';
import '../loading/index.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../loading/icon/gradient.mjs';
import '../_chunks/dep-684f6096.mjs';
import '../_chunks/dep-11896cb9.mjs';
import '../hooks/useTeleport.mjs';
import '../loading/props.mjs';
import '../loading/type.mjs';
import '../button/props.mjs';
import '../hooks/useDisabled.mjs';
import '../button/type.mjs';
import '../dialog/hooks/useSameTarget.mjs';

var Popconfirm = withInstall(_Popconfirm);

export { Popconfirm, Popconfirm as default };
//# sourceMappingURL=index.mjs.map
